var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1169 1366",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1579.2,-6570.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "matrix(0.470998,0,0,0.389395,1579.2,6570.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.3499,0,0,22.1954,581.121,128.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,51C102,22.852 79.148,0 51,0C22.852,0 0,22.852 0,51L0,106C0,134.148 22.852,157 51,157C79.148,157 102,134.148 102,106L102,51Z",
    style: {
      fill: "rgb(241,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.12315,0,0,2.56809,-1154.98,-1711.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 872.173,1148.03 784.788,1188.87C738.468,1210.52 701.953,1248.76 682.456,1296.02C649.816,1375.15 602.51,1489.84 602.51,1489.84L817.958,1580.35L836.241,1544.5C836.241,1544.5 888.09,1706.17 888.555,1762.93C889.02,1819.69 873.153,2031.55 873.153,2031.55L1350.74,2031.55C1350.74,2031.55 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1379.05,1541.88 1379.05,1541.88L1394.57,1580.91L1617.67,1492.78C1617.67,1492.78 1566.71,1373.8 1532.5,1293.94C1512.98,1248.36 1477.54,1211.43 1432.8,1190.06C1345.28,1148.24 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 872.173,1148.03 784.788,1188.87C738.468,1210.52 701.953,1248.76 682.456,1296.02C649.816,1375.15 602.51,1489.84 602.51,1489.84L817.958,1580.35L836.241,1544.5C836.241,1544.5 888.09,1706.17 888.555,1762.93C889.02,1819.69 873.153,2031.55 873.153,2031.55L1350.74,2031.55C1350.74,2031.55 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1379.05,1541.88 1379.05,1541.88L1394.57,1580.91L1617.67,1492.78C1617.67,1492.78 1566.71,1373.8 1532.5,1293.94C1512.98,1248.36 1477.54,1211.43 1432.8,1190.06C1345.28,1148.24 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192.21,1145.23C1192.21,1145.23 1304.6,1197.71 1382.93,1234.3C1427.03,1254.89 1479.39,1244.54 1512.34,1208.71C1512.34,1208.71 1512.34,1208.71 1512.34,1208.71L1142.91,1029.15L1192.21,1145.23Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.695,1608.08L551.729,1481.39C551.729,1481.39 655.914,1488.55 725.548,1493.34C764.8,1496.04 803.564,1483.37 833.647,1458.01C848.137,1445.79 860.368,1435.48 860.368,1435.48L951.013,1670.98L1271.6,1630.13L1357.32,1426.75C1357.32,1426.75 1377.67,1442.86 1398.23,1459.13C1425.51,1480.72 1459.38,1492.27 1494.16,1491.84C1560.42,1491.03 1664.32,1489.76 1664.32,1489.76L1389.3,1918.81C1389.3,1918.81 1299.4,1890.61 1221.62,1866.22C1148.95,1843.43 1071.11,1843.06 998.219,1865.14C904.687,1893.49 786.474,1929.32 786.474,1929.32L830.695,1608.08Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,51.4616,-5.85918)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.56,
    cy: 1138.61,
    rx: 144.58,
    ry: 136.035,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.12315,0,0,2.56809,-1154.98,-1711.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993.138,1434.32L845.782,1434.32L845.782,1623.48L993.138,1623.48L993.138,1434.32ZM1337.48,1473.11L1190.12,1473.11L1190.12,1623.48L1337.48,1623.48L1337.48,1551.4L1344.36,1546.63L1337.48,1540.17L1337.48,1473.11ZM1165.19,1391.61L1017.84,1391.61L1017.84,1623.48L1165.19,1623.48L1165.19,1391.61Z",
    style: {
      fill: "rgb(249,199,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.13,1588.01L1013.3,1588.01L1013.3,1625.51L1171.13,1625.51L1171.13,1588.01ZM1342.74,1588.01L1184.9,1588.01L1184.9,1625.51L1334.22,1625.51L1342.74,1610.54L1342.74,1588.01ZM998.131,1588.01L840.295,1588.01L840.295,1625.51L998.131,1625.51L998.131,1588.01ZM1171.13,1547.73L1013.3,1547.73L1013.3,1585.23L1171.13,1585.23L1171.13,1547.73ZM1342.74,1547.73L1184.9,1547.73L1184.9,1585.23L1342.74,1585.23L1342.74,1547.73ZM998.131,1547.73L840.295,1547.73L840.295,1585.23L998.131,1585.23L998.131,1547.73ZM1171.13,1507.59L1013.3,1507.59L1013.3,1545.1L1171.13,1545.1L1171.13,1507.59ZM1342.74,1507.59L1184.9,1507.59L1184.9,1545.1L1342.74,1545.1L1342.74,1507.59ZM998.131,1507.59L840.295,1507.59L840.295,1545.1L998.131,1545.1L998.131,1507.59ZM1171.13,1466.95L1013.3,1466.95L1013.3,1504.46L1171.13,1504.46L1171.13,1466.95ZM1342.74,1466.95L1184.9,1466.95L1184.9,1504.46L1342.74,1504.46L1342.74,1466.95ZM998.131,1466.95L840.295,1466.95L840.295,1504.46L998.131,1504.46L998.131,1466.95ZM1171.13,1426.67L1013.3,1426.67L1013.3,1464.17L1171.13,1464.17L1171.13,1426.67ZM998.131,1426.67L840.295,1426.67L840.295,1464.17L998.131,1464.17L998.131,1426.67ZM1171.13,1386.54L1013.3,1386.54L1013.3,1424.04L1171.13,1424.04L1171.13,1386.54Z",
    style: {
      fill: "rgb(255,226,112)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1171.13,1588.01L1013.3,1588.01L1013.3,1625.51L1171.13,1625.51L1171.13,1588.01ZM1342.74,1588.01L1184.9,1588.01L1184.9,1625.51L1334.22,1625.51L1342.74,1610.54L1342.74,1588.01ZM998.131,1588.01L840.295,1588.01L840.295,1625.51L998.131,1625.51L998.131,1588.01ZM1171.13,1547.73L1013.3,1547.73L1013.3,1585.23L1171.13,1585.23L1171.13,1547.73ZM1342.74,1547.73L1184.9,1547.73L1184.9,1585.23L1342.74,1585.23L1342.74,1547.73ZM998.131,1547.73L840.295,1547.73L840.295,1585.23L998.131,1585.23L998.131,1547.73ZM1171.13,1507.59L1013.3,1507.59L1013.3,1545.1L1171.13,1545.1L1171.13,1507.59ZM1342.74,1507.59L1184.9,1507.59L1184.9,1545.1L1342.74,1545.1L1342.74,1507.59ZM998.131,1507.59L840.295,1507.59L840.295,1545.1L998.131,1545.1L998.131,1507.59ZM1171.13,1466.95L1013.3,1466.95L1013.3,1504.46L1171.13,1504.46L1171.13,1466.95ZM1342.74,1466.95L1184.9,1466.95L1184.9,1504.46L1342.74,1504.46L1342.74,1466.95ZM998.131,1466.95L840.295,1466.95L840.295,1504.46L998.131,1504.46L998.131,1466.95ZM1171.13,1426.67L1013.3,1426.67L1013.3,1464.17L1171.13,1464.17L1171.13,1426.67ZM998.131,1426.67L840.295,1426.67L840.295,1464.17L998.131,1464.17L998.131,1426.67ZM1171.13,1386.54L1013.3,1386.54L1013.3,1424.04L1171.13,1424.04L1171.13,1386.54Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1082.27,1372.51L1008.2,1372.51L1008.2,1623.48L1082.27,1623.48L1082.27,1372.51ZM1350.82,1372.51L1319.03,1372.51L1319.03,1623.48L1350.82,1623.48L1350.82,1372.51ZM1147.72,1623.48L1253.58,1623.48L1253.58,1372.51L1147.72,1372.51L1147.72,1623.48ZM1003.61,1372.51L971.82,1372.51L971.82,1623.48L1003.61,1623.48L1003.61,1372.51ZM906.363,1372.51L832.298,1372.51L832.298,1623.48L906.363,1623.48L906.363,1372.51Z",
    style: {
      fill: "rgb(255,215,53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.3,1372.51L1102.43,1372.51L1102.43,1623.48L1132.3,1623.48L1132.3,1372.51ZM1303.61,1372.51L1273.74,1372.51L1273.74,1623.48L1303.61,1623.48L1303.61,1372.51ZM956.397,1372.51L926.532,1372.51L926.532,1623.48L956.397,1623.48L956.397,1372.51Z",
    style: {
      fill: "rgb(255,219,76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.26,1372.51L1114.47,1372.51L1114.47,1623.48L1120.26,1623.48L1120.26,1372.51ZM944.358,1372.51L938.571,1372.51L938.571,1623.48L944.358,1623.48L944.358,1372.51ZM1291.57,1372.51L1285.78,1372.51L1285.78,1623.48L1291.57,1623.48L1291.57,1372.51Z",
    style: {
      fill: "rgb(255,238,180)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.889105,0,0,2.95094,426.451,-3325.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030.53,1592.74C1030.53,1577.98 990.802,1566.01 941.792,1566.01L941.792,1566.01C892.781,1566.01 853.051,1577.98 853.051,1592.74C853.051,1592.74 853.051,1592.74 853.051,1592.74C853.051,1607.51 892.781,1619.48 941.792,1619.48C941.792,1619.48 941.792,1619.48 941.792,1619.48C990.802,1619.48 1030.53,1607.51 1030.53,1592.74L1030.53,1592.74Z",
    style: {
      fill: "rgb(255,226,112)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.741505,0,0,2.46106,565.46,-2545.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030.53,1592.74C1030.53,1577.98 990.802,1566.01 941.792,1566.01L941.792,1566.01C892.781,1566.01 853.051,1577.98 853.051,1592.74C853.051,1592.74 853.051,1592.74 853.051,1592.74C853.051,1607.51 892.781,1619.48 941.792,1619.48C941.792,1619.48 941.792,1619.48 941.792,1619.48C990.802,1619.48 1030.53,1607.51 1030.53,1592.74L1030.53,1592.74Z",
    style: {
      fill: "rgb(249,199,0)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030.53,1592.74C1030.53,1577.98 990.802,1566.01 941.792,1566.01L941.792,1566.01C892.781,1566.01 853.051,1577.98 853.051,1592.74C853.051,1592.74 853.051,1592.74 853.051,1592.74C853.051,1607.51 892.781,1619.48 941.792,1619.48C941.792,1619.48 941.792,1619.48 941.792,1619.48C990.802,1619.48 1030.53,1607.51 1030.53,1592.74L1030.53,1592.74Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,2.33826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030.53,1592.74C1030.53,1577.98 990.802,1566.01 941.792,1566.01L941.792,1566.01C892.781,1566.01 853.051,1577.98 853.051,1592.74C853.051,1592.74 853.051,1592.74 853.051,1592.74C853.051,1607.51 892.781,1619.48 941.792,1619.48C941.792,1619.48 941.792,1619.48 941.792,1619.48C990.802,1619.48 1030.53,1607.51 1030.53,1592.74L1030.53,1592.74Z",
    style: {
      fill: "rgb(255,215,53)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,405.708,-941.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860.214,2266.52L863.151,2266.52L863.151,2272.4C869.017,2273.4 873.747,2275.57 877.341,2278.91C880.635,2281.97 885.181,2290.19 885.181,2290.19C885.181,2290.19 885.262,2294.51 885.201,2295.2L873.251,2296.93C872.569,2292.58 871.142,2289.14 868.969,2286.61C867.412,2284.79 865.473,2283.44 863.151,2282.55L863.151,2315.62C870.904,2317.4 876.805,2320.37 880.855,2324.54C885.243,2329.05 887.438,2334.97 887.438,2342.3C887.438,2349.8 885.03,2356.3 880.216,2361.79C875.97,2366.64 870.281,2369.53 863.151,2370.47L863.151,2376.37L850.885,2376.37L850.885,2370.53C843.4,2369.32 837.563,2366.61 833.374,2362.4C828.73,2357.74 826.11,2351.21 825.514,2342.81L825.509,2337.85L837.016,2340.77C837.911,2347.07 839.722,2351.93 842.448,2355.34C844.659,2358.1 847.471,2359.9 850.885,2360.73L850.885,2323.95C843.473,2322.03 837.828,2319.1 833.949,2315.14C829.646,2310.76 827.495,2305.11 827.495,2298.21C827.495,2291.35 829.625,2285.46 833.885,2280.54C837.73,2276.1 843.397,2273.35 850.885,2272.29L850.885,2266.52L853.376,2266.52L853.376,2266.51L860.214,2266.51L860.214,2266.52ZM863.151,2327.08L863.151,2360.49C866.327,2359.52 869.033,2357.79 871.27,2355.31C874.167,2352.09 875.615,2348.03 875.615,2343.13C875.615,2338.83 874.518,2335.37 872.324,2332.75C870.517,2330.59 867.459,2328.7 863.151,2327.08ZM850.885,2282.16C847.44,2283.14 844.713,2284.81 842.704,2287.18C840.233,2290.1 838.997,2293.48 838.997,2297.31C838.997,2301.7 840.276,2305.16 842.832,2307.7C844.893,2309.74 847.577,2311.41 850.885,2312.69L850.885,2282.16Z",
    style: {
      fill: "rgb(249,199,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,405.708,-946.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860.214,2266.52L863.151,2266.52L863.151,2272.4C869.017,2273.4 873.747,2275.57 877.341,2278.91C881.516,2282.78 884.136,2288.22 885.201,2295.2L873.251,2296.93C872.569,2292.58 871.142,2289.14 868.969,2286.61C867.412,2284.79 865.473,2283.44 863.151,2282.55L863.151,2315.62C870.904,2317.4 876.805,2320.37 880.855,2324.54C885.243,2329.05 887.438,2334.97 887.438,2342.3C887.438,2349.8 885.03,2356.3 880.216,2361.79C875.97,2366.64 870.281,2369.53 863.151,2370.47L863.151,2376.37L850.885,2376.37L850.885,2370.53C843.4,2369.32 837.563,2366.61 833.374,2362.4C828.73,2357.74 826.11,2351.21 825.514,2342.81L837.016,2340.77C837.911,2347.07 839.722,2351.93 842.448,2355.34C844.659,2358.1 847.471,2359.9 850.885,2360.73L850.885,2323.95C843.473,2322.03 837.828,2319.1 833.949,2315.14C829.646,2310.76 827.495,2305.11 827.495,2298.21C827.495,2291.35 829.625,2285.46 833.885,2280.54C837.73,2276.1 843.397,2273.35 850.885,2272.29L850.885,2266.52L853.376,2266.52L853.376,2266.51L860.214,2266.51L860.214,2266.52ZM863.151,2327.08L863.151,2360.49C866.327,2359.52 869.033,2357.79 871.27,2355.31C874.167,2352.09 875.615,2348.03 875.615,2343.13C875.615,2338.83 874.518,2335.37 872.324,2332.75C870.517,2330.59 867.459,2328.7 863.151,2327.08ZM850.885,2282.16C847.44,2283.14 844.713,2284.81 842.704,2287.18C840.233,2290.1 838.997,2293.48 838.997,2297.31C838.997,2301.7 840.276,2305.16 842.832,2307.7C844.893,2309.74 847.577,2311.41 850.885,2312.69L850.885,2282.16Z",
    style: {
      fill: "rgb(255,226,112)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(418.302,0,0,505.964,250.963,875.778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.303,-0.412C0.304,-0.412 0.306,-0.411 0.311,-0.41C0.377,-0.397 0.427,-0.373 0.461,-0.339C0.494,-0.304 0.511,-0.259 0.511,-0.203C0.511,-0.146 0.493,-0.096 0.456,-0.054C0.419,-0.012 0.368,0.011 0.303,0.014L0.303,0.057L0.251,0.057L0.251,0.015C0.185,0.008 0.134,-0.014 0.098,-0.05C0.063,-0.085 0.043,-0.135 0.038,-0.199L0.126,-0.215C0.133,-0.167 0.147,-0.13 0.167,-0.104C0.188,-0.077 0.216,-0.063 0.251,-0.059L0.251,-0.339C0.185,-0.353 0.135,-0.377 0.103,-0.411C0.07,-0.444 0.053,-0.487 0.053,-0.54C0.053,-0.592 0.069,-0.637 0.102,-0.675C0.135,-0.713 0.184,-0.734 0.251,-0.74L0.251,-0.782L0.303,-0.782L0.303,-0.74C0.359,-0.735 0.402,-0.717 0.434,-0.688C0.466,-0.658 0.486,-0.616 0.494,-0.563L0.403,-0.55C0.398,-0.583 0.387,-0.609 0.37,-0.629C0.354,-0.648 0.331,-0.66 0.303,-0.666L0.303,-0.412ZM0.251,-0.423L0.251,-0.667C0.215,-0.661 0.188,-0.647 0.169,-0.624C0.151,-0.602 0.141,-0.576 0.141,-0.547C0.141,-0.513 0.151,-0.487 0.17,-0.468C0.19,-0.448 0.217,-0.433 0.251,-0.423ZM0.303,-0.059C0.337,-0.064 0.366,-0.079 0.388,-0.104C0.41,-0.128 0.421,-0.159 0.421,-0.197C0.421,-0.23 0.413,-0.256 0.396,-0.276C0.379,-0.296 0.348,-0.313 0.303,-0.327L0.303,-0.059Z",
    style: {
      fill: "rgb(14,27,91)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.46578,1.85787,1.53598,1.77296,1886.88,-3242.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1406,1565.51C1406,1565.51 1440.09,1636.86 1470.49,1700.51C1496.63,1755.23 1560.92,1780.04 1617.04,1757.07C1617.04,1757.07 1617.04,1757.07 1617.04,1757.07C1631.03,1751.35 1643.37,1742.22 1652.94,1730.53C1694.42,1679.55 1818.78,1525.54 1949.2,1352.36L1889.78,1286.93L1819.33,1328.63L1605.3,1551.04L1581.62,1484.2L1406,1565.51Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1406,1565.51C1406,1565.51 1440.09,1636.86 1470.49,1700.51C1496.63,1755.23 1560.92,1780.04 1617.04,1757.07C1617.04,1757.07 1617.04,1757.07 1617.04,1757.07C1631.03,1751.35 1643.37,1742.22 1652.94,1730.53C1694.42,1679.55 1818.78,1525.54 1949.2,1352.36L1889.78,1286.93L1819.33,1328.63L1605.3,1551.04L1581.62,1484.2L1406,1565.51Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.690381,0.723446,0.723446,0.690381,1420.38,-624.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1269.81,1667.16L1171.9,1693.45C1171.9,1693.45 1107.42,1763.27 1033.74,1778.76C911.811,1804.4 988.039,1683.31 988.039,1683.31L1190.91,1617.62L1269.81,1667.16Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.690381,0.723446,0.723446,0.690381,1420.38,-624.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.72,1591.5C1413.72,1591.5 1561.88,1522.96 1667.77,1592.34L1568.11,1397.06L1388.51,1521.27L1413.72,1591.5Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1889.78,1286.93L1996.03,1260.83L2040.91,1220.06L2123.77,1192.05C2123.77,1192.05 2079.11,1261.01 2062.08,1287.31C2057.82,1293.88 2051.93,1299.23 2044.98,1302.82C2018.06,1316.74 1949.2,1352.36 1949.2,1352.36L1902.16,1352.68L1889.78,1286.93Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26L2070.3,1226.84L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.19,1147.11 2025.69,1133.59C2023.02,1128.05 2025.35,1121.39 2030.89,1118.73C2030.89,1118.73 2030.89,1118.73 2030.89,1118.73C2036.49,1116.03 2043.22,1118.22 2046.16,1123.7C2054.16,1138.6 2068.48,1165.26 2068.48,1165.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.78,1286.93L1898.95,1204.91L1935.62,1223.9L1940.23,1261.63L1889.78,1286.93Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78588,1.38884,-1.14821,2.16014,-621.548,-3081.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1436.49,1607.49 1456.88,1692.76C1472.61,1758.55 1538.47,1799.34 1604.38,1784.11C1604.38,1784.11 1604.38,1784.11 1604.38,1784.11C1620.66,1780.35 1635.39,1771.63 1646.52,1759.15C1693.94,1705.4 1830.88,1544.73 1949.2,1352.36L1889.78,1286.93L1614.96,1545.11L1605.06,1473.86L1412.6,1507.59Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1436.49,1607.49 1456.88,1692.76C1472.61,1758.55 1538.47,1799.34 1604.38,1784.11C1604.38,1784.11 1604.38,1784.11 1604.38,1784.11C1620.66,1780.35 1635.39,1771.63 1646.52,1759.15C1693.94,1705.4 1830.88,1544.73 1949.2,1352.36L1889.78,1286.93L1614.96,1545.11L1605.06,1473.86L1412.6,1507.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817027,0.576599,0.576599,0.817027,1861.47,-627.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.72,1591.5C1413.72,1591.5 1561.88,1522.96 1667.77,1592.34L1568.11,1397.06L1388.51,1521.27L1413.72,1591.5Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,203.717,-266.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2069.39,1198.88 2069.96,1216.43C2070.18,1223.31 2069.11,1230.16 2066.79,1236.64C2060.79,1253.38 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,203.717,-266.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.18,1147.1 2025.68,1133.58C2023.02,1128.04 2025.35,1121.4 2030.88,1118.73C2030.88,1118.73 2030.88,1118.73 2030.88,1118.73C2036.49,1116.04 2043.22,1118.24 2046.14,1123.72C2054.1,1138.63 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1889.78,1286.93L1996.03,1260.83L2040.91,1220.06L2070.3,1226.62C2070.3,1226.62 2064.26,1255.63 2059.92,1276.49C2057.18,1289.68 2048.66,1300.95 2036.72,1307.2C2005.03,1323.76 1944.59,1355.37 1944.59,1355.37L1889.78,1286.93Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2053.45,1158.03L2068.49,1165.25L2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.19,1147.11 2025.69,1133.59C2023.02,1128.05 2025.35,1121.39 2030.89,1118.73C2030.89,1118.73 2030.89,1118.73 2030.89,1118.73C2036.49,1116.03 2043.22,1118.22 2046.16,1123.7C2054.16,1138.6 2068.48,1165.26 2068.48,1165.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.808982,0.587833,-0.587833,0.808982,1122.37,-879.992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894.61,1301.89C1894.61,1301.89 1892.53,1290.31 1890.66,1279.9C1888.74,1269.19 1888.8,1258.22 1890.84,1247.53C1894.15,1230.13 1898.95,1204.91 1898.95,1204.91L1935.62,1223.9L1941.13,1277.36L1894.61,1301.89Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0148953,-0.999889,-0.999889,-0.0148953,3145.24,3164.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1898.62,1204.95C1898.62,1204.95 1930.84,1186.59 1946.83,1177.48C1952,1174.53 1958.51,1175.45 1962.66,1179.72C1962.66,1179.72 1962.66,1179.72 1962.66,1179.72C1965.1,1182.22 1966.43,1185.59 1966.37,1189.08C1966.3,1192.57 1964.84,1195.89 1962.32,1198.3C1951.51,1208.61 1935.39,1224 1935.39,1224L1898.62,1204.95Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18633,0,0,1.18351,-293.605,-150.263)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.55,783.328L1217.88,875.608L1194.05,883.916L1002.92,1021.74L993.138,937.112L1176.61,798.509L1210.55,783.328Z",
    style: {
      fill: "rgb(6,19,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1120.52,1046.06C1120.52,1046.06 1120.52,1046.06 1120.52,1046.06C1141.32,1046.86 1157.77,1063.95 1157.77,1084.77C1157.77,1148.48 1157.77,1271.53 1157.77,1271.53L1384.15,1066.07L1150.1,964.475L1120.52,1046.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.413,1145.18C991.413,1145.18 1010.22,1105.14 1024.57,1074.59C1034.34,1053.8 1055.26,1040.53 1078.23,1040.56C1089.09,1040.58 1098.07,1040.59 1098.07,1040.59L993.281,902.438L991.413,1145.18Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78314,0.185352,0.152875,2.16196,3101.34,-1539.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996345,-0.08542,0.08542,0.996345,-69.2749,125.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1198.6,926.866L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-742.346,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.08555,17.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1139.54,958.416 1112.67,947.414L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,46.074,-111.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1053.25,957.559 1015.04,886.977L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.996725,-0.0808635,-0.0808635,0.996725,2320.61,90.5101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040.71,860.602L1070.97,845.406L1108.26,851.058L1092.94,863.021L1069.43,854.485L1040.71,860.602Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999523,0.0308927,-0.0308927,0.999523,27.0585,-32.5891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029.29,870.664L1056.11,850.009L1093.8,848.49L1081.02,863.139L1056.32,859.216L1029.29,870.664ZM1085.52,864.318L1100,848.49L1107.09,848.1L1091.45,865.162L1085.52,864.318Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035.21,773.294C1035.21,773.294 1152.65,853.022 1227.65,791.222C1227.65,791.222 1251.66,771.063 1267.88,715.731C1267.88,715.731 1234.4,697.261 1194.05,698.691L1196.88,679.63C1196.88,679.63 1129.37,674.664 1092.03,713.884L1092.03,687.487C1092.03,687.487 1052.64,731.568 1025.02,737.448C997.398,743.328 993.637,741.917 993.637,741.917C986.58,785.704 984.889,828.665 989.446,870.664C998.491,871.329 1004.56,875.182 1009.21,880.553C1009.21,880.553 1018.33,788.288 1035.21,773.294Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-731.005,-1319.13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1172.38,
    cy: 882.086,
    rx: 6.709,
    ry: 8.079,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.75,875.368 1161.19,879.642L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3302.68,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.91,875.309 1161.36,879.583L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-894.318,-1319.13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1172.38,
    cy: 882.086,
    rx: 6.709,
    ry: 8.079,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.09,977.305C1085.09,977.305 1106.57,984.859 1139.47,983.004L1138.77,999.097C1138.77,999.097 1102.36,1003.48 1085.09,977.305Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.73664,0,0,2.69773,-2464.4,107.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "rgb(14,27,91)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyMoney);
export default __webpack_public_path__ + "static/media/guy_money.b9bec988659b6023506cd161ba0e3912.svg";
export { ForwardRef as ReactComponent };